// @flow
import React from 'react';
import {Box, IconButton, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {useState} from 'react';
import {
  Publish,
  CheckCircleRounded,
  FiberManualRecord,
} from '@material-ui/icons';
import {colors} from '../../../../assets/styles/colors';
import Close from '@material-ui/icons/Close';
import PremiumFeatureBadge from '../../../../elements/PremiumFeatureBadge/PremiumFeatureBadge';
import {useEffect} from 'react';

type ComponentsEvents = {
  onUploadImage: (file: File[]) => void,
  handleRemoveNewImage: (index: number) => void,
  handleClose: () => void,
  handleSetVariantImage: (imageId: string | number) => void,
};
type Props = {
  open: boolean,
  editImages: {id: string, url: string}[],
  newEditImages: string[],
  uploadDisabled: boolean,
  defaultVariantImage: string | number,
  multiple?: boolean,
} & ComponentsEvents;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyItems: 'center',
    alignItems: 'center',
    textAlign: 'center',
    // width: 320,
    // height: 240,
    padding: theme.spacing(4),
    maxWidth: '100%',
  },
  title: {
    fontWeight: 600,
    fontSize: '1.375rem',
  },
  subtitle: {
    color: colors.grey700,
  },
  bigImagesContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'flex-start',
    maxWidth: '100%',
  },
  imagesContainer: {
    display: 'flex',
    maxWidth: 600,
    overflowX: 'auto',
    minHeight: 120,
  },
  imageBox: {
    display: 'flex',
    height: 120,
    width: 120,
    minWidth: 120,
    justifyContent: 'center',
    alignSelf: 'center',
    alignItems: 'center',
    textAlign: 'center',
    position: 'relative',
    borderRadius: '12px',
    marginRight: 16,
    overflow: 'hidden',
    // '&:nth-child(2)': {
    //   border: `2px solid ${colors.purple3}`,
    // },
    // '&:nth-child(2):after': {
    //   content: '"PORTADA"',
    //   position: 'absolute',
    //   color: 'white',
    //   bottom: 0,
    //   left: 0,
    //   width: '100%',
    //   background: colors.purple3,
    //   // borderRadius: `0 0 3px 3px`,
    //   padding: 6,
    //   fontWeight: 600,
    //   fontSize: '0.875rem',
    // },
    cursor: 'pointer',
    '&:hover': {
      border: `2px solid ${colors.grey500}`,
    },
  },
  addImageBox: {
    opacity: 0.8,
    cursor: 'pointer',
    border: `2px dashed ${colors.grey500}`,
    '&:hover': {
      opacity: 1,
      backgroundColor: colors.grey200,
    },
  },
  uploadIcon: {
    color: colors.purple3,
    backgroundColor: colors.lightPurple,
    borderRadius: 40,
  },
  imageBoxDisabled: {
    opacity: 0.8,
    cursor: 'default',
    '&:hover': {
      opacity: 0.8,
      backgroundColor: 'initial',
      border: `2px dashed ${colors.grey500}`,
    },
  },
  // secondaryImages: {
  //   border: 'none',
  // },
  image: {
    // width: '100%',
    height: 'auto',
    // borderRadius: theme.shape.borderRadius,
    /*boxShadow: theme.shadows[2],*/
    maxHeight: '100%',
    objectFit: 'contain',
  },
  removeImageIcon: {
    position: 'absolute',
    top: 4,
    right: 4,
    padding: 4,
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: colors.grey300,
    },
  },
  selectedImage: {
    border: `2px solid ${colors.purple3} !important`,
  },
  selectedIcon: {
    position: 'absolute',
    bottom: 4,
    right: 4,
    color: colors.purple3,
  },
  row: {
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
  upsellMessage: {
    width: 'fit-content',
    backgroundColor: colors.lightPurple,
    color: colors.purple3,
    fontSize: '0.875rem',
    borderRadius: '12px',
    padding: theme.spacing(1, 2),
  },
  buttonContainer: {
    width: '100%',
    marginTop: theme.spacing(4),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  confirmButton: {
    height: 36,
    width: 200,
  },
}));

export default function ChooseVariantImageModal(props: Props) {
  const {
    open,
    handleClose,
    editImages,
    newEditImages,
    onUploadImage,
    handleRemoveNewImage,
    uploadDisabled,
    handleSetVariantImage,
    defaultVariantImage,
    multiple,
  } = props;

  const classes = useStyles();

  const [selectedImage, setSelectedImage] = useState<string | number>('');

  const handleCloseModal = () => {
    setSelectedImage('');
    handleClose();
  };

  const handleConfirm = () => {
    handleCloseModal();
    handleSetVariantImage(selectedImage);
  };

  useEffect(() => {
    setSelectedImage(defaultVariantImage);
  }, [defaultVariantImage]);

  const handleInputChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files) return;
    onUploadImage(Array.from(files));
  };

  return (
    <CustomModal open={open} handleCloseModal={handleCloseModal}>
      <div className={classes.root}>
        <Typography gutterBottom className={classes.title}>
          Selecciona una imagen variante
        </Typography>
        <Typography gutterBottom className={classes.subtitle}>
          Estas imagénes apareceran cuando se seleccione la variante respectiva
        </Typography>
        <div className={classes.bigImagesContainer}>
          <label
            className={`${classes.imageBox} ${classes.addImageBox} ${
              uploadDisabled ? classes.imageBoxDisabled : ''
            }`}
          >
            <input
              onChange={handleInputChange}
              type="file"
              name="file"
              hidden
              accept="image/*"
              multiple={multiple}
            />
            <Box>
              <IconButton
                aria-label="add"
                className={classes.uploadIcon}
                size="small"
                disabled={uploadDisabled}
                // onClick={handleAddImageClick}
              >
                <Publish color="primary" />
              </IconButton>
            </Box>
          </label>
          <div className={classes.imagesContainer}>
            {editImages &&
              editImages.map((image, index) => (
                <div
                  key={index}
                  className={`${classes.imageBox} ${classes.secondaryImages} ${
                    image.id === selectedImage ? classes.selectedImage : ''
                  }`}
                  onClick={() => setSelectedImage(image.id)}
                  onDoubleClick={handleConfirm}
                >
                  <img
                    className={classes.image}
                    src={image.url}
                    alt="no artifact that depicts visual perception for you"
                  />
                  {image.id === selectedImage && (
                    <>
                      <FiberManualRecord
                        className={classes.selectedIcon}
                        style={{color: 'white'}}
                      />
                      <CheckCircleRounded className={classes.selectedIcon} />
                    </>
                  )}
                  {/* <IconButton
              aria-label={'cancel'}
              className={classes.removeImageIcon}
              onClick={_ => handleRemoveActualImage(index)}
              disabled={isSaving}
            >
              <Close fontSize="small" />
            </IconButton> */}
                </div>
              ))}
            {newEditImages &&
              newEditImages.map((image, index) => (
                <div
                  key={index}
                  className={`${classes.imageBox} ${classes.secondaryImages} ${
                    index === selectedImage ? classes.selectedImage : ''
                  }`}
                  onClick={() => setSelectedImage(index)}
                  onDoubleClick={handleConfirm}
                >
                  <img
                    className={classes.image}
                    src={image}
                    alt="no artifact that depicts visual perception for you"
                  />
                  {index === selectedImage && (
                    <>
                      <FiberManualRecord
                        className={classes.selectedIcon}
                        style={{color: 'white'}}
                      />
                      <CheckCircleRounded className={classes.selectedIcon} />
                    </>
                  )}
                  <IconButton
                    aria-label={'cancel'}
                    className={classes.removeImageIcon}
                    onClick={_ => handleRemoveNewImage(index)}
                    // disabled={isSaving}
                  >
                    <Close fontSize="small" />
                  </IconButton>
                </div>
              ))}
          </div>
        </div>
        {uploadDisabled && (
          <div className={classes.row}>
            <div className={classes.upsellMessage}>
              Mejora tu plan y carga más fotos. Muestra distintos ángulos del
              producto
            </div>
            <PremiumFeatureBadge />
          </div>
        )}
        <div className={classes.buttonContainer}>
          <div />
          <CustomButton
            variant="contained"
            onClick={handleConfirm}
            className={classes.confirmButton}
          >
            Confirmar
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
}
